import { WCCContentCardsScoreAnswerBlock } from "components/content/blocks/cardsScoreAnswer/cardsScoreAnswer";
import { wccModules } from "enums/wccModules";
import { inject, injectable } from "inversify";
import { Subscribable } from "knockout";
import { CardsScoreAnswer } from "models/cardsScoreAnswer";
import WCCContentBlockVM from "../block/block";
import './cardsScoreAnswer.html';

components.preload('cards-score-answers');

@injectable()
export default class WCCContentCardsScoreAnswerBlockVM extends WCCContentBlockVM {
    topicId: Subscribable<string | undefined>
    answers: Subscribable<Array<CardsScoreAnswer>>

    constructor(
        @inject(wccModules.componentConfig) block: WCCContentCardsScoreAnswerBlock,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(block, info);

        this.topicId = block.topicId;
        this.answers = block.answer.pluck(answer => [answer], []);
    }
}